import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// ACTIONS
import { modalActions } from '../actions';

const ConfirmModal = () => {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modal);

  const closeModal = () => {
    dispatch(modalActions.close());
  };

  return (
    <Modal isOpen={modal.visible} toggle={closeModal} centered={true}>
      {modal.title && (
        <ModalHeader toggle={closeModal}>{modal.title}</ModalHeader>
      )}
      <ModalBody>{modal.body}</ModalBody>
      {modal.buttons && <ModalFooter>{modal.buttons}</ModalFooter>}
    </Modal>
  );
};

export default ConfirmModal;
